module.exports = __webpack_public_path__ + "12897b73eff3df55fb339ebbd6738c73.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/containers/StaticPage/ComeBack/assets/sec-5/reviews-section-5/review-2.jpg
// module id = ./app/containers/StaticPage/ComeBack/assets/sec-5/reviews-section-5/review-2.jpg
// module chunks = 40